import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { TERMS_CONDITIONS } from '../data/legalContent';
export function TermsConditionsPage() {
  return <div className="min-h-screen bg-gray-50" data-id="element-816">
      {/* Header */}
      <div className="bg-white border-b border-gray-200" data-id="element-817">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-6" data-id="element-818">
          <a href="/" className="inline-flex items-center text-purple-600 hover:text-purple-700 font-medium transition-colors" data-id="element-819">
            <ArrowLeft className="w-5 h-5 mr-2" data-id="element-820" />
            Back to Home
          </a>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-821">
        <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12" data-id="element-822">
          <h1 className="text-4xl font-bold text-gray-900 mb-8" data-id="element-823">
            Terms & Conditions
          </h1>

          <div className="prose prose-sm max-w-none" data-id="element-824">
            {TERMS_CONDITIONS.split('\n\n').map((paragraph, index) => {
            const isHeading = paragraph.match(/^[A-Z\s]+$/) || paragraph.match(/^\d+\.\s+[A-Z]/);
            const isSubheading = paragraph.match(/^[A-Z][a-z\s]+:$/);
            if (paragraph === 'Terms & Conditions') {
              return null; // Skip duplicate title
            }
            if (paragraph.startsWith('Last Updated:')) {
              return <p key={index} className="text-sm text-gray-500 mb-8" data-id="element-825">
                    {paragraph}
                  </p>;
            }
            if (isHeading) {
              return <h2 key={index} className="text-xl font-bold text-gray-900 mt-8 mb-4" data-id="element-826">
                    {paragraph}
                  </h2>;
            }
            if (isSubheading) {
              return <h3 key={index} className="text-lg font-semibold text-gray-800 mt-6 mb-3" data-id="element-827">
                    {paragraph}
                  </h3>;
            }
            return <p key={index} className="text-gray-700 leading-relaxed mb-4" data-id="element-828">
                  {paragraph}
                </p>;
          })}
          </div>
        </div>
      </div>
    </div>;
}